import React, { useContext } from "react";

import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import useLabels from "../../../../../customHooks/useLabels";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { payloadTypes } from "../../../../../context/reducer";
import { AppContext } from "../../../../../context/context";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { TicketListProps } from "./TicketWiseIndex";
import { TicketsQueryType } from "../../../../../queries/types";
import { useNavigate } from "react-router-dom";
import { empType } from "../../../../../utils/Enum.types";
const List = ({ queryType }: TicketListProps) => {
  const { dispatch } = useContext(AppContext);

  const { customer_id, company_id } = useUrlParams();

  const navigate = useNavigate();

  const { state } = useContext(AppContext);

  const rows1: GridValidRowModel[] = [
    {
      id: 1,
      description: "Tickets",
      ItemId: 1,
      dashBoardLink: `/${customer_id}/reports/ticketwise`,
      link: `/${customer_id}/company/${company_id}/reports/ticketwise`,
      type: TicketsQueryType.ALL,
    },
    {
      id: 2,
      description: "SLA Reports",
      ItemId: 2,
      dashBoardLink: `/${customer_id}/reports/slawise`,
      link: `/${customer_id}/company/${company_id}/reports/slawise`,
      type: TicketsQueryType.SLA_REPORT,
    },
  ];

  const { itemLabel } = useLabels();
  const columns: GridColDef[] = [
    {
      headerName: itemLabel,
      cellClassName: "td-link",
      field: "description",
      headerAlign: HEADER_TEXT_ALIGN,
      flex: FlexForColumns.DESCRIPTION,
      hideable: false,
    },
  ];

  return (
    <>
      <div className="asset-reports__left--list">
        <StyledDatagrid
          getCellClassName={(params) =>
            params.row.type === queryType ? "active" : ""
          }
          columns={columns}
          rows={rows1}
          rowHeight={TABLE_ROW_HEIGHT}
          disableRowSelectionOnClick
          hideFooter
          onRowClick={(params) => {
            if (params.row.type === TicketsQueryType.ALL) {
              if (state.empSubType === empType.SYS_ADMIN) {
                navigate(params.row.link);
              } else {
                navigate(params.row.dashBoardLink);
              }
            } else {
              if (state.empSubType === empType.SYS_ADMIN) {
                navigate(params.row.link);
              } else {
                navigate(params.row.dashBoardLink);
              }
            }
          }}
        />
      </div>
    </>
  );
};

export default List;
